module.exports = __webpack_public_path__ + "img/NORDIC_FERMENTED_MILK.0d948766.png";